import { TThunkAction } from '../../../../common/types/thunk';
import { selectShouldPayByCard } from '../../../selectors/publishAvailable';
import { createAnalytics } from '../../../../AppModulesWrapper';
import { selectCanFillBalance } from '../../../selectors/balance';
import { setIsSubagentNotEnoughMoney } from '../../../actions/publishInfo';
import { openTopUpBalance } from '../../../actions/webview';
import { PUBLISH_PAYMENT_STARTED_EVENT } from '../../../constants/events';
import { sendEvent } from '../../../utils/sendEvent';
import { publishOfferThunk } from '../publishOffer';
import { selectTotalAmount } from '../../../selectors/checkoutInfo';

export const processPublishOfferThunk =
  (): TThunkAction =>
  (dispatch, getState, { webview, logger }) => {
    const state = getState();

    const shouldPayByCard = selectShouldPayByCard(state);
    const canFillBalance = selectCanFillBalance(state);
    const totalPrice = selectTotalAmount(state);

    const analytics = createAnalytics({ getState, logger });

    if (shouldPayByCard) {
      // Трекает открытие модалки пополнения счёта
      analytics.send({ action: 'not_enough_money_popup_open', label: 'add_offer' });

      // Трекает неудачную попытку публикации объявления из-за недостатка средств
      analytics.send({ action: 'FailedToPublish', label: 'not_enough_money' });

      if (canFillBalance) {
        sendEvent(PUBLISH_PAYMENT_STARTED_EVENT);

        webview.sendAction(openTopUpBalance(totalPrice.price));
      } else {
        dispatch(setIsSubagentNotEnoughMoney(true));
      }
    } else {
      dispatch(publishOfferThunk());
    }
  };
